import { render, staticRenderFns } from "./traching-banner.vue?vue&type=template&id=8dedad18"
import script from "./traching-banner.vue?vue&type=script&lang=js"
export * from "./traching-banner.vue?vue&type=script&lang=js"
import style0 from "./traching-banner.vue?vue&type=style&index=0&id=8dedad18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports